module.exports = "/_next/static/images/31727e93f26e3b65598d9860077cc3a1-roxinho-scene-card-with-phone-lg@3x.jpg";